<div class="wrapper">
  <div class="tab-measurements" aria-hidden="true" inert>
    @for (header of visibleHeaders; track header.id) {
      <span class="header text-type-3" [class.selected]="selectedTabId === header.id">{{ header.label }}</span>
    }
    <span class="header text-type-3">More</span>
  </div>
  <div class="header-section flex justify-start items-start gap-[32px]">
    @for (header of visibleHeaders | slice:0:inlineTabCount; track header) {
      @if (header.display) {
        <div
          [attr.data-testid]="'tab-header-' + header.id"
          (click)="selectHeader(header)"
          [class.selected]="selectedTabId === header?.id"
          class="header text-type-3 cursor-pointer text-[#60698B]"
          >
          {{ header.label }}
        </div>
      }
    }
    @if (!hidesMoreMenu) {
      <div
        [class.selected]="selectedTabLabel"
        [matMenuTriggerFor]="menu"
       
        [overlapTrigger]="false"
        data-testid="tab-menu-more"
        class="header text-type-3 cursor-pointer text-[#60698B] flex justify-center items-center"
        >
        {{ selectedTabLabel || 'More' }}
        <span>
          <mat-icon
            [svgIcon]="'chevron-down'"
            class="chevron-icon"
            />
        </span>
      </div>
    }
    <mat-menu #menu="matMenu" class="tab-more-menu">
      @for (header of visibleHeaders | slice:inlineTabCount; track header) {
        @if (header.display) {
          <button
            [attr.data-testid]="'tab-menu-item-' + header.id"
            (click)="selectMenu(header)"
            [class.tab-more-menu-item--selected]="selectedTabId === header.id"
            mat-menu-item
            >
            {{ header.label }}
          </button>
        }
      }
    </mat-menu>
    <!-- Diary filter chips sit on the tab row, like the daily-report lists'
         "Filter (N)" / "All Time" chips. Browsing only: the record view
         replaces them with its date strip. -->
    @if (selectedTabId === 15 && !diaryDetailMode) {
      <div class="header-actions ml-auto flex flex-row items-center gap-[20px]">
        <app-daily-diary-filters />
      </div>
    } @else {
      <div class="header-actions ml-auto flex flex-row items-center">
        <ng-content></ng-content>
      </div>
    }
  </div>
  @if (selectedTabId !== null) {
    <div class="content-section">
      @switch (selectedTabId) {
        @case (0) {
          <app-site-wise-reports
            class="tab-content"
            />
        }
        @case (1) {
          <app-submittals-wrapper
            class="tab-content"
            />
        }
        @case (2) {
          <app-rfis-wrapper
            class="tab-content"
            />
        }
        @case (3) {
          @if (!displayActivityCodes) {
            <app-pay-app
              class="tab-content"
              />
          }
        }
        @case (4) {
          <app-change-order-tab-wrapper
            class="tab-content"
            />
        }
        @case (5) {
          @if (currentUser?.roles[0]?.role === 'project-manager' && displayActivityCodes) {
            <app-activity-codes-list
              class="tab-content"
              />
          }
        }
        @case (6) {
          <app-consolidated-report-wrapper
            class="tab-content"
            />
        }
        @case (9) {
          <app-delivery-tracking-tab-wrapper
            class="tab-content"
            />
        }
        @case (8) {
          @if (!isContractorMode) {
            <app-each-project-settings
              class="tab-content"
              />
          }
        }
        @case (7) {
          <app-documents-wrapper
            class="tab-content"
            />
        }
        @case (19) {
          <app-drawings-wrapper class="tab-content" />
        }
        @case (11) {
          <app-warranty-wrapper
            class="tab-content"
            />
        }
        @case (12) {
          <app-samples-wrapper
            class="tab-content"
            />
        }
        @case (13) {
          <app-punchlist-wrapper
            class="tab-content"
            />
        }
        @case (14) {
          <app-mapped-report-list-page
            class="tab-content"
            />
        }
        @case (15) {
          <app-project-diaries-wrapper
            class="tab-content"
            />
        }
        @case (16) {
          <app-mgvw-records-wrapper
            class="tab-content"
            />
        }
        @case (18) {
          <app-risk-register-wrapper
            class="tab-content"
            />
        }
        @case (17) {
          <app-project-issues-tab
            class="tab-content"
            />
        }
      }
    </div>
  }
</div>
